import React from "react"
import {PlanningEdit} from "components/front/PLANNING/Planning/Edit/PlanningEdit"

export const PlanningAddRoute = () => {
  return <div>
    <PlanningEdit />
  </div>
}